import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { GraduationCap, History as HistoryIcon, LogOut, User, Sparkles, Gift } from 'lucide-react';
import { InstallPWAButton } from '@/components/InstallPWAButton';

export function AppShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 border-b bg-card">
        <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="brand-home">
            <div className="grid h-9 w-9 place-items-center rounded-lg bg-red-600 text-white shadow-[0_0_20px_rgba(239,68,68,0.35)]">
              <GraduationCap className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-base font-semibold">StudyTrack AI</div>
              <div className="text-[11px] text-muted-foreground">NCERT · JEE · NEET</div>
            </div>
          </Link>
          {user ? (
            <div className="flex items-center gap-2">
              <InstallPWAButton
                variant="outline"
                size="sm"
                className="border-red-500/40 text-red-500 hover:bg-red-500/10 hover:text-red-500"
              />
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/referral')}
                data-testid="nav-referral-button"
                className="gap-1.5"
              >
                <Gift className="h-4 w-4" />
                <span className="hidden sm:inline">Refer & Earn</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/pricing')}
                data-testid="nav-pricing-button"
                className="gap-1.5"
              >
                <Sparkles className="h-4 w-4" />
                <span className="hidden sm:inline">Plans</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/history')}
                data-testid="nav-history-button"
                className="gap-1.5"
              >
                <HistoryIcon className="h-4 w-4" />
                <span className="hidden sm:inline">History</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/profile')}
                data-testid="nav-profile-button"
                className="gap-1.5"
              >
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">{user.name?.split(' ')[0] || 'Profile'}</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  logout();
                  navigate('/login');
                }}
                data-testid="nav-logout-button"
                className="gap-1.5"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          ) : null}
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 sm:py-8">{children}</main>
      <footer className="mx-auto w-full max-w-6xl px-4 pb-8 pt-4 text-center text-xs text-muted-foreground sm:px-6">
        Built for serious students — NCERT-aligned. AI generates fresh questions every attempt.
      </footer>
    </div>
  );
}
